export var LessonCategory;
(function (LessonCategory) {
    LessonCategory["COMPREHENSION"] = "COMPREHENSION";
    LessonCategory["PLACEMENT_TEST"] = "PLACEMENT_TEST";
    LessonCategory["ADAPTIVE_LEARNING"] = "ADAPTIVE_LEARNING";
})(LessonCategory || (LessonCategory = {}));
export var CurriculumComponent;
(function (CurriculumComponent) {
    CurriculumComponent["LITERACY"] = "LITERACY";
    CurriculumComponent["FOUNDATIONAL_VOCABULARY"] = "FOUNDATIONAL_VOCABULARY";
})(CurriculumComponent || (CurriculumComponent = {}));
export var LessonTabName;
(function (LessonTabName) {
    LessonTabName["PLACEMENT_TEST"] = "PLACEMENT_TEST";
    // common
    LessonTabName["COMPREHENSION"] = "COMPREHENSION";
    LessonTabName["LANGUAGE_STUDY"] = "LANGUAGE_STUDY";
    // fr
    LessonTabName["FLUENCY"] = "FLUENCY";
    LessonTabName["DECHIFFRAGE"] = "DECHIFFRAGE";
    LessonTabName["MATHEMATICS"] = "MATHEMATICS";
    LessonTabName["FOUNDATIONAL_VOCABULARY"] = "FOUNDATIONAL_VOCABULARY";
    // en
    LessonTabName["SIGHT_WORD"] = "SIGHT_WORD";
    LessonTabName["WORD_FAMILY"] = "WORD_FAMILY";
    LessonTabName["PHONICS"] = "PHONICS";
    LessonTabName["VOCABULARY"] = "VOCABULARY";
})(LessonTabName || (LessonTabName = {}));
export var LessonStatus;
(function (LessonStatus) {
    LessonStatus["DRAFT"] = "DRAFT";
    LessonStatus["PUBLISHED"] = "PUBLISHED";
})(LessonStatus || (LessonStatus = {}));
export var LessonValidationStatus;
(function (LessonValidationStatus) {
    LessonValidationStatus["INSUFFICIENT_DATA"] = "INSUFFICIENT_DATA";
    LessonValidationStatus["STRUGGLING"] = "STRUGGLING";
    LessonValidationStatus["VALIDATED"] = "VALIDATED";
    LessonValidationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    LessonValidationStatus["SKIPPED"] = "SKIPPED";
})(LessonValidationStatus || (LessonValidationStatus = {}));
export var PlacementTestStatus;
(function (PlacementTestStatus) {
    PlacementTestStatus["NOT_STARTED"] = "NOT_STARTED";
    PlacementTestStatus["IN_PROGRESS"] = "IN_PROGRESS";
    PlacementTestStatus["COMPLETED"] = "COMPLETED";
})(PlacementTestStatus || (PlacementTestStatus = {}));
export var PlacementTestGamificationStatus;
(function (PlacementTestGamificationStatus) {
    PlacementTestGamificationStatus["introduction"] = "introduction";
    PlacementTestGamificationStatus["middle"] = "middle";
    PlacementTestGamificationStatus["conclusion"] = "conclusion";
})(PlacementTestGamificationStatus || (PlacementTestGamificationStatus = {}));
export var LessonTransition;
(function (LessonTransition) {
    LessonTransition["NONE"] = "NONE";
    LessonTransition["LESSON"] = "LESSON";
    LessonTransition["REVIEW"] = "REVIEW";
    LessonTransition["ASSIGNMENT"] = "ASSIGNMENT";
})(LessonTransition || (LessonTransition = {}));
//# sourceMappingURL=lesson.js.map